import React, { useEffect, useState } from "react";
import api from "../lib/api";
import { fmtMoney, fmtPrice } from "../components/Format";

export default function History() {
  const [trades, setTrades] = useState([]);
  const [filter, setFilter] = useState("all");

  async function refresh() {
    try {
      const r = await api.get("/trades", { params: { limit: 500 } });
      setTrades(r.data);
    } catch { /* ignore transient refresh failures */ }
  }
  useEffect(() => {
    refresh();
    const id = setInterval(refresh, 3000);
    return () => clearInterval(id);
  }, []);

  const filtered = trades.filter((t) => filter === "all" || t.mode === filter);

  return (
    <div className="space-y-6" data-testid="history-page">
      <div>
        <div className="label-xs">Lifetime Executions</div>
        <h1 className="text-3xl font-[Chivo] tracking-tight">Trade History</h1>
      </div>

      <div className="flex gap-1 max-w-xs" data-testid="history-filter">
        {["all", "paper", "live"].map((f) => (
          <button
            key={f}
            data-testid={`history-filter-${f}`}
            onClick={() => setFilter(f)}
            className={`flex-1 text-xs font-[Chivo] tracking-wider py-1.5 border ${
              filter === f
                ? "bg-[#007AFF] text-white border-[#007AFF]"
                : "border-border text-neutral-400 hover:text-white"
            }`}
          >
            {f.toUpperCase()}
          </button>
        ))}
      </div>

      <div className="border border-border bg-[#0F0F0F]">
        <div className="px-4 py-3 border-b border-border text-xs text-neutral-400 label-xs">
          {filtered.length} records
        </div>
        <div className="overflow-auto">
          <table className="w-full text-sm">
            <thead>
              <tr className="border-b border-border">
                <th className="text-left px-3 py-2 label-xs">Closed</th>
                <th className="text-left px-3 py-2 label-xs">Symbol</th>
                <th className="text-left px-3 py-2 label-xs">Mode</th>
                <th className="text-left px-3 py-2 label-xs">Strategy</th>
                <th className="text-left px-3 py-2 label-xs">Exchange</th>
                <th className="text-right px-3 py-2 label-xs">Entry</th>
                <th className="text-right px-3 py-2 label-xs">Exit</th>
                <th className="text-right px-3 py-2 label-xs">Qty</th>
                <th className="text-right px-3 py-2 label-xs">PnL</th>
              </tr>
            </thead>
            <tbody>
              {filtered.length === 0 && (
                <tr><td colSpan={9} className="px-3 py-10 text-center text-neutral-500">No history yet.</td></tr>
              )}
              {filtered.map((t) => (
                <tr key={t.id} className="border-b border-border hover:bg-[#141414]">
                  <td className="px-3 py-2 num text-xs text-neutral-400">{new Date(t.closed_at).toLocaleString()}</td>
                  <td className="px-3 py-2 font-[Chivo]">{t.symbol}</td>
                  <td className="px-3 py-2 text-xs text-neutral-400">{t.mode}</td>
                  <td className="px-3 py-2 text-xs text-neutral-400">{t.strategy}</td>
                  <td className="px-3 py-2 text-xs text-neutral-400">{t.exchange}</td>
                  <td className="px-3 py-2 text-right num">${fmtPrice(t.entry_price)}</td>
                  <td className="px-3 py-2 text-right num">${fmtPrice(t.exit_price)}</td>
                  <td className="px-3 py-2 text-right num">{t.qty.toFixed(6)}</td>
                  <td className={`px-3 py-2 text-right num ${t.pnl >= 0 ? "profit" : "loss"}`}>{t.pnl >= 0 ? "+" : ""}${fmtMoney(t.pnl, 3)}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}
